// extracted by mini-css-extract-plugin
module.exports = {"icon_close":"CloseIcon_icon_close__zb1BH","icon_close2":"CloseIcon_icon_close2__3QrZ8","icon_open":"CloseIcon_icon_open__1SVrZ"};